import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  VacationWidget,
  VacationWidgetComponent
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AirportDropdownComponent,
  AnalyticsDataPopulateService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  AirportDropDown,
  AirportDropDownList,
  DestinationType,
  FROM,
  TO
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { MessageBanner } from '@com-delta-omnichannel/mach-core-js';
import { PushPipe } from '@ngrx/component';
import { BookingVacationFacadeService } from '../../../data-access/facades/booking-vacation/booking-vacation-facade.service';
import { WidgetHeightDirective } from '../../../directives/booking-vacation/widget-height.directive';

@Component({
  selector: 'idp-booking-vacation',
  standalone: true,
  imports: [
    CommonModule,
    VacationWidgetComponent,
    AirportDropdownComponent,
    PushPipe
  ],
  hostDirectives: [WidgetHeightDirective],
  templateUrl: './booking-vacation.component.html',
  styleUrls: ['./booking-vacation.component.scss']
})
export class BookingVacationComponent implements OnInit, OnChanges {
  analyticsService = inject(AnalyticsDataPopulateService);
  bookingVacationFacadeService = inject(BookingVacationFacadeService);
  private widgetHeight = inject(WidgetHeightDirective);

  @Input() viewSearchOptionExpanded = false;
  @Input() isSelected = false;
  @Output() expandEmit = new EventEmitter<boolean>(false);

  originAirport: AirportDropDownList = { code: '', name: '' };
  destinationAirport: AirportDropDownList = { code: '', name: '' };
  destinationType: DestinationType = '';
  openModalEvent = false;
  airportModalContent!: AirportDropDown;
  isReady = false;
  showAlert = false;
  formResetTrigger = 0;
  messageBanner!: MessageBanner;
  emptyVacationContent = {} as VacationWidget;
  resetErrors = false;

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    const target = event.target as HTMLElement;
    const originButton = target.closest('#from-and-to-origin-button');
    const destinationButton = target.closest('#from-and-to-destination-button');
    if (originButton) {
      this.destinationType = FROM;
      this.onDestinationTypeSelected(FROM);
    } else if (destinationButton) {
      this.destinationType = TO;
      this.onDestinationTypeSelected(TO);
    }
  }

  ngOnInit(): void {
    this.widgetHeight.addHeight();
    this.bookingVacationFacadeService.init(this.onInitComplete);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isSelected'] &&
      !changes['isSelected'].firstChange &&
      !this.isSelected
    ) {
      this.resetErrors = true;
      this.openModalEvent = false;
      setTimeout(() => (this.resetErrors = false));
    }
  }

  onInitComplete = (success: boolean): void => {
    this.isReady = success;
    if (success) {
      this.widgetHeight.removeHeight();
      this.airportModalContent =
        this.bookingVacationFacadeService.displayAirportModalList(FROM, '');
    } else {
      setTimeout(() => {
        this.showAlert = true;
        this.messageBanner = new MessageBanner(
          this.bookingVacationFacadeService.adapter.setErrorBanner()
        );
      }, 100);
    }
  };

  onAirportSelected(airport: AirportDropDownList): void {
    if (this.destinationType === FROM) {
      this.originAirport = airport;
    } else if (this.destinationType === TO) {
      this.destinationAirport = airport;
    }
  }

  onDestinationTypeSelected(destination: DestinationType): void {
    this.bookingVacationFacadeService.destinationType$.next(destination);
  }

  formSubmitted(): void {
    this.bookingVacationFacadeService.formSubmitted();
  }

  searchValue(searchTerm: string): void {
    const type = this.bookingVacationFacadeService.destinationType$.getValue();
    const selectedCode =
      type === FROM ? this.originAirport.code : this.destinationAirport.code;
    this.airportModalContent =
      this.bookingVacationFacadeService.displayAirportModalList(
        type,
        searchTerm,
        selectedCode
      );
  }
}
